



















































import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import LabelPrintItem from './LabelPrintItem.vue';
import { ApiService } from '@/services/ApiService';
import { LABEL_SELECTION, Mutations } from '@/store/types';
import { ConfigService } from '@/services/ConfigService';
import Store from '@/store';
import { LabelSelectionApi, ProductDto } from '@eurogast/hub-client-typescript';
import ConfirmationActionButton from '@/common/ConfirmationActionButton.vue';
import MatomoEvents from '@/matomo/events/MatomoEvents';
import ProductGroup from '@/domain/labels/ProductGroup';

const labelSelection = namespace(LABEL_SELECTION);

@Component({
  components: { LabelPrintItem, ConfirmationActionButton }
})
export default class LabelPrintList extends Vue {

  @labelSelection.State('labelSelectionSkuMap')
  public labelSelectionSkuMap: Array<{ sku: string; amount: number }>;

  public localProducts: ProductDto[] = [];

  private labelSelectionApi = ApiService.wrap(LabelSelectionApi);

  public clearLabelPrintList() {
    MatomoEvents.forLabelPage.removeAll.publish();
    this.labelSelectionApi.clearOwnLabelPrintList(ConfigService.getTenant(), ConfigService.currentCustomerId)
      .then(() => {
        Store.commit(Mutations.LabelSelection.clearSkus);
        this.localProducts = [];
        (this.$refs.confirmationActionButton as ConfirmationActionButton).hideDialog();
      })
      .catch(ApiService.defaultErrorHandler);
  }

  get pdfParams() {
    let result = '';
    this.labelSelectionSkuMap.forEach((item) => {
      result += item.sku + '::' + item.amount + ';';
    });
    return result;
  }

  get labelAmounts() {
    return this.labelSelectionSkuMap.map((label) => label.amount);
  }

  get labelNames() {
    return this.localProducts.map((product) => product.name);
  }

  get totalQuantity() {
    let count = 0;
    this.labelAmounts.forEach((amount) => count += amount);
    return count;
  }

  get labelCount() {
    if (!this.labelSelectionSkuMap) {
      return 0;
    }
    return this.labelSelectionSkuMap.length;
  }

  get productsGroupedByCategory(): ProductGroup[] {
    const productsByCategory = new Map<string, ProductDto[]>();

    this.localProducts.forEach((product) => {
      const categoryId = product.resolvedCategory.id;

      if (!productsByCategory.has(categoryId)) {
        productsByCategory.set(categoryId, []);
      }

      productsByCategory.get(categoryId).push(product);
    });

    const productGroups = Array.from(
        productsByCategory,
        ([_, products]) => new ProductGroup(products)
    );

    productGroups.sort((group1, group2) => group1.categoryId.localeCompare(group2.categoryId));
    productGroups.forEach((group) =>
        group.products.sort((product1, product2) => product1.name.localeCompare(product2.name))
    );

    return productGroups;
  }

  public imagePath(item: ProductDto): string {
    return (item.images && item.images.length > 0) ? item.images[0].thumbnailPath : '';
  }

  public trackLabelListGeneration() {
    MatomoEvents.forLabelPage.generateList.publish();
  }

  public initializeProducts() {
    this.labelSelectionApi.getProductsForLabelPrint(ConfigService.getTenant(), ConfigService.currentCustomerId)
      .then((products) => {
        this.localProducts = products;
      }).catch(ApiService.defaultErrorHandler);
  }

  public mounted() {
    Vue.prototype.$events.$once('init-label-prints', () => {
      this.initializeProducts();
    });
  }
}
